import {Link} from 'react-router-dom'
import Header from '../Header/index'
import './index.css'

const Home = () => (
  <div className="homemdiv">
    <Header />
    <div className="homediv">
      <h1>Find The Job That Fits Your Life</h1>
      <p>
        Millions of people are searching for jobs, salary information, company
        reviews. Find the job that fits your abilities and potential.
      </p>
      <Link to="/jobs">
        <button type="button" className="homebtn">
          Find Jobs
        </button>
      </Link>
    </div>
  </div>
)

export default Home
